import React, { useState, useId } from 'react';
import styled from 'styled-components';
import { useAppContext } from 'src/components/app-context';
import { media } from 'src/components/base';
import { ClickOutButton } from '../click-out-button';
import { Popover, Alignment } from '@prisjakt/ui/popover';
import { BodySmallText } from '@prisjakt/ui/text/variants';
import type { BaseProps } from '../../types';

type Props = Pick<BaseProps, 'store' | 'link' | 'onClick'>;

export const ListCardOfferFooter: React.FC<Props> = props => {
  const { store, link, onClick } = props;
  const { t } = useAppContext();
  const [showPopover, setShowPopover] = useState(false);
  const uid = useId();
  const disabled = !onClick || !link;

  const handleClick = () => {
    if (disabled) {
      setShowPopover(true);
    }

    if (onClick) {
      onClick();
    }
  };

  return (
    <ButtonWrapper>
      <ClickOutButton
        store={store}
        href={link || ''}
        onClick={handleClick}
        featured={store && store.featured}
        containerProps={{ 'aria-describedby': `offer-${uid}` }}
      />

      {disabled && (
        <Popover
          id={`offer-${uid}`}
          visible={showPopover}
          width={250}
          offsetY={0}
          offsetX={0}
          verticalAlign={Alignment.Center}
          horizontalAlign={Alignment.End}
          onClose={() => setShowPopover(false)}
          zIndex={20}
        >
          <BodySmallText>
            {t('product', 'transparency.store-info')}
          </BodySmallText>
        </Popover>
      )}
    </ButtonWrapper>
  );
};

const ButtonWrapper = styled.div`
  max-width: 250px;
  min-width: 200px;
  height: 100%;
  display: flex;
  align-items: center;

  ${media.mediumDown`
    max-width: 100%;
    grid-column-start: 1;
    grid-column-end: 3;
  `}
`;
